import React, { useState } from "react";
import "./Cortes.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent";

const cortesBovinos = ["Maminha", "Cupim", "Alcatra", "Costela", "Picanha"];

const detalhesCorte = {
  Maminha: "A maminha é macia, ideal para assar ou grelhar, com sabor suave.",
  Cupim: "O cupim é suculento, ótimo para churrasco lento e defumado.",
  Alcatra: "A alcatra é macia e suculenta, ideal para grelhar, assar ou churrasco.",
  Costela: "A costela é rica em sabor, perfeita para cozidos ou churrascos longos.",
  Picanha: "A picanha é nobre, macia e extremamente saborosa, ótima para grelhar."
};

const Cortes = () => {
  const [corteAtivo, setCorteAtivo] = useState("Alcatra");

  return (
    <div className="cortes-wrapper">
      <h2 className="cortes-subtitle">Cortes Bovinos</h2>

      <div className="cortes-content">
        {/* MENU LATERAL */}
        <aside className="cortes-left">
          <h3>Tipos de Corte</h3>
          <ul>
            {cortesBovinos.map((corte) => (
              <li
                key={corte}
                className={corte === corteAtivo ? "ativo" : ""}
                onClick={() => setCorteAtivo(corte)}
              >
                {corte}
              </li>
            ))}
          </ul>
        </aside>

        {/* CONTEÚDO */}
        <section className="cortes-right">
          <div className="cortes-card">
            <div className="cortes-header">
              <h3>{corteAtivo}</h3>
            </div>

            {/* IMAGEM PRINCIPAL */}
            <img
              src={Imagens[corteAtivo] || Imagens.Alcatra}
              alt={corteAtivo}
              className="corte-principal"
            />

            {/* MAPA DO BOI */}
            <div className="corte-extra">
              <img
                src={Imagens.CorteBovino}
                alt="Mapa do corte no boi"
              />
              <div>
                <strong>Localização do corte</strong>
                <p>{detalhesCorte[corteAtivo]}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Cortes;
